"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAlphaMapFromAlphaChannel = void 0;
var _createCanvas = require("./createCanvas");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Algorithm:
 * 1. copy the source canvas on a working canvas
 * 2. make it's content white keeping the alpha values
 * 3. draw it on the target canvas using the higher alpha value
 * @param {HTMLCanvasElement} srcCanvas The canvas that has transparency
 * @param {HTMLCanvasElement} dstCanvas The target canvas that holds the alpha map
 */
var createAlphaMapFromAlphaChannel = exports.createAlphaMapFromAlphaChannel = function createAlphaMapFromAlphaChannel(srcCanvas, dstCanvas) {
  var _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(srcCanvas, true),
    _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 2),
    tmpCanvas = _createWorkingCanvas2[0],
    tmpCtx = _createWorkingCanvas2[1];
  // draw a white rectangle over the source content using the source-in operation
  // to make the source image white keeping the alpha values
  tmpCtx.globalCompositeOperation = "source-in";
  tmpCtx.fillStyle = "white";
  tmpCtx.fillRect(0, 0, srcCanvas.width, srcCanvas.height);

  // copy the content alpha to the target canvas using the lighten operation
  // to keep the higher alpha value of the two maps
  var dstCtx = dstCanvas.getContext("2d");
  var globalCompositeOperation = dstCtx.globalCompositeOperation;
  dstCtx.globalCompositeOperation = "lighten";
  dstCtx.drawImage(tmpCanvas, 0, 0);
  dstCtx.globalCompositeOperation = globalCompositeOperation;
};